import {restfulClient, actionClient} from "@/api";
import config from '@/config/index'
import store from "@/store";

const musicScoreUrl = '/music/score'
const codeUrl = '/music/code'
const codeApiUrl = '/music/code-api'
const musicSongUrl = '/music/song'
const accompanimentUrl = '/music/accompaniment'
const playUrl = '/music/play'
const overheadUrl = '/music/overhead'
const miniCodeUrl = '/music/mini-code'
const selectMiniCode = '/music/select-mini-code'
export const musicSongStatisticExportUrl = 'music/song-statistic-export'

export function createMiniCode(params) {
    return actionClient.get(miniCodeUrl, {query: params})
}

export function getMusicSelectMiniCode(params) {
    return actionClient.get(selectMiniCode, {query: params})
}

export function listScore(params) {
    let queryParams = {...params}
    if (params.name) queryParams.query = {'name': `%${params.name}%`}
    return restfulClient.getCollection(musicScoreUrl, queryParams)
}

export function createScore(params) {
    return restfulClient.create(musicScoreUrl, params)
}

export function updateScore(params) {
    return restfulClient.update(musicScoreUrl, params.id, params)
}

export function listSong(params) {
    let queryParams = {...params}
    queryParams.query = {'music_score_id': params.music_score_id}
    queryParams.withRels = ['accompaniment', 'play', 'overhead']
    if (params.name) queryParams.query.name = `%${params.name}%`
    return restfulClient.getCollection(musicSongUrl, queryParams)
}

// export function createSong(params) {
//     return restfulClient.create(musicSongUrl, params)
// }

export function updateSong(params) {
    return restfulClient.update(musicSongUrl, params.id, params)
}

export function listAccompaniment(params) {
    let queryParams = {...params}
    if (params.name) queryParams.query = {'name': `%${params.name}%`}
    if (params.searchText) queryParams.query = {'searchText': params.searchText}
    return restfulClient.getCollection(accompanimentUrl, queryParams)
}

export function createAccompaniment(params) {
    return restfulClient.create(accompanimentUrl, params)
}

export function updateAccompaniment(params) {
    return restfulClient.update(accompanimentUrl, params.id, params)
}

export function deleteAccompaniment(id) {
    return restfulClient.remove(accompanimentUrl, id)
}

export function listPlay(params) {
    let queryParams = {...params}
    if (params.name) queryParams.query = {'name': `%${params.name}%`}
    if (params.searchText) queryParams.query = {'searchText': params.searchText}
    return restfulClient.getCollection(playUrl, queryParams)
}

export function createPlay(params) {
    return restfulClient.create(playUrl, params)
}

export function updatePlay(params) {
    return restfulClient.update(playUrl, params.id, params)
}

export function deletePlay(id) {
    return restfulClient.remove(playUrl, id)
}

export function listOverhead(params) {
    let queryParams = {...params}
    if (params.name) queryParams.query = {'name': `%${params.name}%`}
    if (params.searchText) queryParams.query = {'searchText': params.searchText}
    return restfulClient.getCollection(overheadUrl, queryParams)
}

export function createOverhead(params) {
    return restfulClient.create(overheadUrl, params)
}

export function updateOverhead(params) {
    return restfulClient.update(overheadUrl, params.id, params)
}

export function deleteOverhead(id) {
    return restfulClient.remove(overheadUrl, id)
}

export function createCode(params) {
    return actionClient.post(codeUrl, params)
}

export function listCode(params) {
    let queryParams = {...params}
    queryParams.query = {'music_score_id': params.music_score_id}
    if (params.code) queryParams.query.code = `%${params.code}%`
    if (params.write_off !== undefined) {
        queryParams.query.write_off = params.write_off
    }
    return restfulClient.getCollection(codeApiUrl, queryParams)
}

export function deleteCode(id) {
    return restfulClient.remove(codeApiUrl, id)
}

export function exportCode(params) {
    const {token} = store.state.auth
    let url = config.api.baseURL + codeUrl + '?token=' + token + '&music_score_id=' + params.music_score_id
    if (params.code) url += '&code=' + params.code
    if (params.write_off !== undefined) url += '&write_off=' + params.write_off
    window.open(url)
}
